import React, { useRef } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { Form } from "react-bootstrap";

import { TextInput, FormFilter, SubmitSearchButton, ClearFiltersButton, Select } from "components/forms";
import { fetchDomains, fetchLifeSettlementChoices } from "actions";
import { managementChoicesSelector } from "reducers";
import { DOMAIN_ACCOUNT_TYPES } from "./constants";

const DomainForm = ({ ...props }) => {
  React.useEffect(() => {
    props.fetchLifeSettlementChoices();
  }, []);
  let initialValues = {};

  // Account Type Type Multi Select //
  const accountTypeRef = useRef();
  let [accountType, setAccountType] = React.useState("");
  const handleAccountTypeChange = selectedOptions => {
    if (selectedOptions) {
      const commaSeparatedStatusValues = selectedOptions.map(o => o.value).join(",");
      setAccountType(commaSeparatedStatusValues);
    } else {
      setAccountType(undefined);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        values.account_type = accountType;
        await props.fetchDomains(values);
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, resetForm }) => {
        return (
          <FormFilter title={"Domains Search"} onSubmit={handleSubmit}>
            <Form.Row>
              <TextInput label="URL" name="url" md={4} />
              <Select
                label="Domain Type"
                name="type"
                placeholder="Select Domain Type"
                options={[
                  { value: 1, label: "Protected" },
                  { value: 2, label: "Common" },
                ]}
                md={4}
              />
            </Form.Row>
            <Form.Row>
              <TextInput label="Company Name" name="company_name" md={4} />
              <Select
                label="Account Type"
                name="account_type"
                placeholder="Select Account Type(s)"
                options={DOMAIN_ACCOUNT_TYPES}
                isMulti={true}
                submitRef={accountTypeRef}
                onChange={handleAccountTypeChange}
                defaultValue={[]}
              />
            </Form.Row>
            <Form.Row>
              <Select
                label="Sales Rep"
                name="sales_representative_id"
                placeholder="Select Sales Rep"
                options={props.salesRepChoices?.getChoices({ sortByLabel: true }) || []}
                md={4}
              />
            </Form.Row>
            <SubmitSearchButton />
            <ClearFiltersButton onClick={resetForm} />
          </FormFilter>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);
  return {
    salesRepChoices: choices.case_sales_representatives,
  };
};

export default connect(mapStateToProps, {
  fetchDomains,
  fetchLifeSettlementChoices,
})(DomainForm);
